import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import {ErrorService, EventService} from '..';

import { ConfigService } from './config.service';
import { LabelResponse, Label, CreateUpdateLabelRequest } from '../models';



@Injectable({providedIn: 'root'})
export class LabelService {
    private labelURL = ConfigService.getApiEndpoint() + 'v1/label/';

    constructor(
        private http: HttpClient,
        private eventService: EventService,
        private error: ErrorService
    ) { }

    search(query: any): Observable<LabelResponse> {
        return this.http.get<LabelResponse>(this.labelURL + 'search', { params: query }).pipe(
                catchError(this.error.handleError('getAllLabels', null))
        );
    }

    getAll(): Observable<Label[]> {
        return this.http.get<Label[]>(this.labelURL).pipe(
            catchError(this.error.handleError('getAllLabels', null))
        );
    }

    getOne(id: number): Observable<Label> {
        return this.http.get<Label>(this.labelURL + id).pipe(
            catchError(this.error.handleError('getOneLabel', null))
        );
    }

    create(request: CreateUpdateLabelRequest): Observable<Label> {
        return this.http.post<Label>(this.labelURL, request).pipe(
            tap(_ => this.eventService.addAlert(`created label`)),
            catchError(this.error.handleError('createLabel', null))
        );
    }

    update(request: CreateUpdateLabelRequest): Observable<Label> {
        return this.http.put<Label>(this.labelURL + request.id, request).pipe(
            tap(_ => this.eventService.addAlert(`updated label: ${request.name},  ${request.color}`)),
            catchError(this.error.handleError('updateLabel', null))
        );
    }

    delete(label: Label): Observable<Label> {
        return this.http.delete<Label>(this.labelURL + label.id).pipe(
            tap(_ => this.eventService.addAlert(`deleted label`)),
            catchError(this.error.handleError('deleteLabel', null))
        );
    }
}
